import { SpellList } from "../../../data/spells";
import { COINS } from "../../../tiles";
import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { TextButton } from "../../../ui/input/TextButton";
import { ComponentF, createElement } from "../../../ui/ui";
import { withColor } from "../../../ui/uiText";
import { Spell } from "../../actors/Spell";
import { hasRequirements } from "../../actors/spellUtils";
import Colors from "../../Colors";
import { gameData } from "../../GameManager";
import { isDownKey, isUpKey } from "../keyHelper";
import { SpellDetailDisplay } from "./SpellDetailDisplay";

export const SpellListModal: ComponentF<void> = (C) => {
  const [state, setState] = C.useState({ selected: 0 });
  let selectedSpell: Spell | null = null;

  floodFill(C.display, C.bounds, Colors.OFF_BLACK);

  C.display.drawText(
    C.bounds.x,
    C.bounds.y,
    withColor(Colors.GRAY_2, "Choose a spell to learn:"),
    C.bounds.w - 1
  );
  let y = C.bounds.y + 1;
  let canBuySelected = false;
  const filtered = SpellList.filter(
    (spell) => !gameData.player.book.find((s) => s.id === spell.id)
  );
  filtered.forEach((spell, index) => {
    const canBuy =
      hasRequirements(spell, gameData.player) && spell.cost <= gameData.xp;

    const selected = index === state.selected;
    if (selected) {
      selectedSpell = new Spell(spell);
      canBuySelected = canBuy;
    }

    C.display.drawText(
      C.bounds.x,
      y,
      withColor(selected ? Colors.AQUA_3 : Colors.EGGSHELL, spell.name),
      C.bounds.w - 1
    );
    y += C.display.drawText(
      C.bounds.x + C.bounds.w - 6,
      y,
      withColor(
        canBuy ? (selected ? Colors.AQUA_2 : Colors.EGGSHELL) : Colors.RED,
        `${spell.cost}${COINS}`
      ),
      C.bounds.w - 1
    );
  });

  C.handlers.press = (p: [number, number]) => {
    const newSelected = p[1] - 2;
    if (newSelected >= 0 && newSelected < filtered.length) {
      setState({
        selected: newSelected,
      });
    }
  };

  C.handlers.keypress = (key: string) => {
    if (isUpKey(key)) {
      setState({ selected: Math.max(0, state.selected - 1) });
    } else if (isDownKey(key)) {
      setState({
        selected: Math.min(filtered.length - 1, state.selected + 1),
      });
    }
    return true;
  };

  return [
    createElement(
      SpellDetailDisplay,
      { x: 0, y: C.bounds.h - 6, w: C.bounds.w, h: 6 },
      { spell: selectedSpell, missingRequirements: true }
    ),
    createElement(
      TextButton,
      { x: C.bounds.w - 13, y: C.bounds.h - 1, w: C.bounds.w - 1, h: 1 },
      {
        title: "Confirm",
        keyLabel: "Enter",
        keys: ["Enter"],
        disabled: !canBuySelected,
        onClick: () => {
          if (selectedSpell) {
            if (
              hasRequirements(selectedSpell, gameData.player) &&
              selectedSpell.cost <= gameData.xp
            ) {
              gameData.xp -= selectedSpell.cost;
              gameData.player.book.add(selectedSpell.id, selectedSpell);

              if (selectedSpell.onAdded) {
                selectedSpell.onAdded.apply(gameData.player, {
                  valid: true,
                  actor: gameData.player,
                });
              }
              setState({ selected: 0 });
              closeModal();
            } else {
              setState({ ...state, message: `Not enough ${COINS}` });
            }
          }
        },
      }
    ),
    createElement(
      TextButton,
      { x: 0, y: C.bounds.h - 1, w: 10, h: 1 },
      {
        title: "Cancel",
        keyLabel: "Esc",
        keys: ["Escape", "Tab"],
        onClick: () => {
          closeModal();
        },
      }
    ),
  ];
};
